import { SubmissionInboundEmail } from 'types';
import { CapitolaClient } from './base';

export default class SubmissionInboundEmailClient extends CapitolaClient<SubmissionInboundEmail> {
  public get resourceName(): string {
    return 'submission-inbound-email';
  }
}
